import appendix from '@/data/garmin/tailored_strength_workout.json';

export type StrengthAppendixCategory = {
  value: string;
  label: string;
  exerciseNames: string[];
};

export type StrengthAppendixExercise = {
  value: string;
  label: string;
  category: string;
  categories: string[];
};

export type StrengthAppendix = {
  source: {
    provider: 'garmin';
    document: string;
    version: string;
    generatedAt: string;
  };
  categories: StrengthAppendixCategory[];
  exerciseNames: StrengthAppendixExercise[];
};

const data = appendix as StrengthAppendix;

export const getStrengthCategories = () => data.categories;

export const getStrengthCategoryLabels = () =>
  data.categories.map((category) => category.label);

export const getStrengthExercisesByCategory = (categoryLabel: string) => {
  const normalized = categoryLabel.trim().toLowerCase();
  return data.exerciseNames.filter((exercise) =>
    exercise.categories.some(
      (category) => category.toLowerCase() === normalized
    )
  );
};

export const isValidStrengthCategory = (value: string) =>
  data.categories.some(
    (category) =>
      category.value.toLowerCase() === value.trim().toLowerCase() ||
      category.label.toLowerCase() === value.trim().toLowerCase()
  );

export const isValidStrengthExercise = (value: string, category?: string) => {
  const normalized = value.trim().toLowerCase();
  return data.exerciseNames.some((exercise) => {
    const matchesValue = exercise.value.toLowerCase() === normalized;
    const matchesLabel = exercise.label.toLowerCase() === normalized;
    if (!(matchesValue || matchesLabel)) return false;

    if (!category) return true;
    const categoryValue = category.trim().toLowerCase();
    return exercise.categories.some(
      (candidate) => candidate.toLowerCase() === categoryValue
    );
  });
};

export const strengthAppendix = data;
